/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from "yup";

const lineItemSchema = Yup.object().shape({
  productId: Yup.string().required("Product is required"),
  productName: Yup.string().required(),
  quantity: Yup.number()
    .typeError("Quantity must be a number")
    .required("Quantity is required")
    .min(1, "Quantity must be at least 1"),
  unitPrice: Yup.number()
    .typeError("Unit price must be a number")
    .required("Unit price is required")
    .min(0, "Unit price must be positive"),
  unit: Yup.string().optional(),
  itemEntries: Yup.array().optional()
});

export const salesOrderSchema = Yup.object().shape({
  customerId: Yup.string().optional(),
  expectedDeliveryDate: Yup.string().optional(),
  terms: Yup.string().optional(),
  tax: Yup.number().typeError("Must be a number").optional(),
  shippingCost: Yup.number().typeError("Must be a number").optional(),
  currency: Yup.string().required("Currency is required"),
  notes: Yup.string().optional(),
  lineItems: Yup.array()
    .of(lineItemSchema)
    .min(1, "At least one line item is required")
});

export const purchaseOrderSchema = Yup.object().shape({
  supplierId: Yup.string().required("Supplier ID is required"),
  expectedDeliveryDate: Yup.string().optional(),
  terms: Yup.string().optional(),
  tax: Yup.number().typeError("Must be a number").optional(),
  shippingCost: Yup.number().typeError("Must be a number").optional(),
  currency: Yup.string().required("Currency is required"),
  notes: Yup.string().optional(),
  lineItems: Yup.array()
    .of(lineItemSchema)
    .min(1, "At least one line item is required")
});
